import IMessageHandler from "./IMessageHandler";
import LocalStubEngine from "./LocalStubEngine";

export default class WebSocketClient {
    connected: boolean;
    ws?: WebSocket;
    stubEngine?: LocalStubEngine;
    messageHandler: IMessageHandler;
    constructor(messageHandler: IMessageHandler) {
        this.connected = false;
        this.messageHandler = messageHandler;
    }

    send(data: string) {
        if (this.stubEngine != null) {
            this.stubEngine.receive(data);
            return;
        }
        if (this.connected && this.ws != null) {
            this.ws.send(data);
        }
    }

    connect(connectionURL: string): Promise<void> {
        // QUANTA: "local://" URLs are answered by the in-page stub engine
        // (used by the published live preview — no backend needed).
        if (connectionURL.indexOf("local://") === 0) {
            return new Promise((resolve) => {
                this.stubEngine = new LocalStubEngine(this.messageHandler);
                this.stubEngine.open(() => {
                    this.connected = true;
                    this.messageHandler.handleOpenConnection();
                    resolve();
                });
            });
        }
        return new Promise((resolve, reject) => {
            this.ws = new WebSocket(connectionURL);

            this.ws.onopen = evt => {
                this.connected = true;
                this.messageHandler.handleOpenConnection();
                resolve();
            };

            this.ws.onclose = evt => {
                this.connected = false;
                this.messageHandler.handleCloseConnection();
            };

            this.ws.onmessage = evt => {
                this.messageHandler.handleMessage(evt.data);
            };

            this.ws.onerror = evt => {
                if (!this.connected) {
                    reject('Cannot connect to host');
                }
                this.connected = false;
                this.messageHandler.handleConnectionError();
            };
        });
    }
}
